(function(){
'use strict';
var $ = function(s, r){ return (r || document).querySelector(s); };
var $$ = function(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
var FMT = (window.SZ && window.SZ.moneyFormat) || '${{amount}}';
function money(cents){
cents = Math.round(cents);
var v = (cents / 100).toFixed(2);
var parts = v.split('.');
parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
var amount = parts.join('.');
return FMT.replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, amount);
}
window.SZmoney = money;
$$('[data-sz-timer]').forEach(function(el){
var hours = parseFloat(el.getAttribute('data-hours') || '0');
var endAttr = el.getAttribute('data-end');
var end = endAttr ? Date.parse(endAttr) : NaN;
var key = 'sz_timer_end';
function evergreen(){
var stored = 0;
try { stored = parseInt(localStorage.getItem(key) || '0', 10); } catch(e){}
if (!stored || stored < Date.now()) { stored = Date.now() + hours * 3600 * 1000; try { localStorage.setItem(key, String(stored)); } catch(e){} }
return stored;
}
if (isNaN(end) || end < Date.now()) end = hours > 0 ? evergreen() : Date.now();
var d = $('[data-d]', el), h = $('[data-h]', el), m = $('[data-m]', el), s = $('[data-s]', el);
function pad(n){ return (n < 10 ? '0' : '') + n; }
function tick(){
var diff = Math.max(0, end - Date.now());
if (diff === 0 && hours > 0) { try { localStorage.removeItem(key); } catch(e){} end = evergreen(); diff = end - Date.now(); }
var t = Math.floor(diff / 1000);
d.textContent = pad(Math.floor(t / 86400)); h.textContent = pad(Math.floor(t % 86400 / 3600)); m.textContent = pad(Math.floor(t % 3600 / 60)); s.textContent = pad(t % 60);
}
tick(); setInterval(tick, 1000);
});
var mnav = $('[data-sz-mnav]');
$$('[data-sz-mnav-open]').forEach(function(b){ b.addEventListener('click', function(){ mnav && mnav.classList.add('is-open'); }); });
$$('[data-sz-mnav-close]').forEach(function(b){ b.addEventListener('click', function(){ mnav && mnav.classList.remove('is-open'); }); });
var toTop = $('[data-sz-totop]');
if (toTop) {
toTop.addEventListener('click', function(){ window.scrollTo({ top: 0, behavior: 'smooth' }); });
window.addEventListener('scroll', function(){ toTop.classList.toggle('is-show', window.scrollY > 600); }, { passive: true });
}
$$('[data-sz-modal-open]').forEach(function(b){
b.addEventListener('click', function(e){ e.preventDefault(); var m = document.getElementById(b.getAttribute('data-sz-modal-open')); if (m) m.classList.add('is-open'); });
});
$$('.sz-modal').forEach(function(m){
m.addEventListener('click', function(e){ if (e.target === m || e.target.closest('[data-sz-modal-close]')) m.classList.remove('is-open'); });
});
$$('[data-sz-slider]').forEach(function(sl){
var track = $('[data-sz-track]', sl);
var step = function(){ var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 12 : 270; };
var prev = $('[data-sz-prev]', sl), next = $('[data-sz-next]', sl);
prev && prev.addEventListener('click', function(){ track.scrollBy({ left: -step(), behavior: 'smooth' }); });
next && next.addEventListener('click', function(){
if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) track.scrollTo({ left: 0, behavior: 'smooth' });
else track.scrollBy({ left: step(), behavior: 'smooth' });
});
});
var cartEl = $('[data-sz-cart]');
function openCart(){ if (!cartEl) { window.location.href = '/cart'; return; } cartEl.classList.add('is-open'); renderCart(); }
function closeCart(){ cartEl && cartEl.classList.remove('is-open'); }
window.SZopenCart = openCart;
$$('[data-sz-cart-open]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); openCart(); }); });
$$('[data-sz-cart-close]').forEach(function(b){ b.addEventListener('click', closeCart); });
function setCount(n){ $$('[data-sz-count]').forEach(function(c){ c.textContent = n; c.setAttribute('data-count', n); }); }
function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]; }); }
function renderCart(){
if (!cartEl) return;
fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); }).then(function(cart){
setCount(cart.item_count);
var body = $('[data-sz-cart-body]', cartEl);
$$('[data-sz-cart-n]', cartEl).forEach(function(n){ n.textContent = cart.item_count; });
if (!cart.items.length) {
body.innerHTML = '<div class="sz-cart__empty"><b>Your cart is empty.</b><a href="' + esc(cartEl.getAttribute('data-shop-url') || '/') + '" class="sz-btn sz-btn--gold">Shop now</a></div>';
$('[data-sz-subtotal]', cartEl).textContent = money(0);
var dz = $('[data-sz-disc]', cartEl); if (dz) dz.innerHTML = '';
return;
}
body.innerHTML = cart.items.map(function(it, i){
var img = it.image ? '<img src="' + esc(it.image) + '" alt="" loading="lazy">' : '';
var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="sz-ci__v">' + esc(it.variant_title) + '</div>' : '';
var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
return '<div class="sz-ci" data-line="' + (i + 1) + '"><div class="sz-ci__img">' + img + '</div><div><div class="sz-ci__t">' + esc(it.product_title) + '</div>' + variant +
'<div class="sz-ci__q"><button type="button" data-q="' + (it.quantity - 1) + '">−</button><span>' + it.quantity + '</span><button type="button" data-q="' + (it.quantity + 1) + '">+</button></div><br>' +
'<button type="button" class="sz-ci__rm" data-q="0">Remove</button></div><div class="sz-ci__p">' + money(it.final_line_price) + was + '</div></div>';
}).join('');
$('[data-sz-subtotal]', cartEl).textContent = money(cart.total_price);
var disc = $('[data-sz-disc]', cartEl);
if (disc) { var saved = cart.total_discount || 0; disc.innerHTML = saved > 0 ? '<span>Bundle savings</span><span>−' + money(saved) + '</span>' : ''; }
});
}
if (cartEl) {
cartEl.addEventListener('click', function(e){
var b = e.target.closest('[data-q]'); if (!b) return;
var line = b.closest('[data-line]').getAttribute('data-line');
fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: parseInt(line, 10), quantity: Math.max(0, parseInt(b.getAttribute('data-q'), 10)) }) }).then(renderCart);
});
fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){ setCount(c.item_count); });
}
function alertLite(msg){ var n = document.createElement('div'); n.textContent = msg; n.style.cssText = 'position:fixed;left:50%;top:20px;transform:translateX(-50%);background:#111;color:#fff;padding:10px 16px;border-radius:8px;z-index:99;font-size:13px'; document.body.appendChild(n); setTimeout(function(){ n.remove(); }, 3500); }
function addItems(items, btn){
if (btn) { btn.disabled = true; btn.setAttribute('data-label', btn.textContent); btn.textContent = 'Adding…'; }
return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
.then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); })
.then(function(){ openCart(); })
.catch(function(err){ alertLite((err && (err.description || err.message)) || 'Could not add to cart.'); })
.finally(function(){ if (btn) { btn.disabled = false; btn.textContent = btn.getAttribute('data-label'); } });
}
$$('[data-sz-product]').forEach(function(root){
var dataEl = $('script[data-sz-product-json]', root);
if (!dataEl) return;
var P = JSON.parse(dataEl.textContent);
var colorIdx = P.colorIndex, sizeIdx = P.sizeIndex;
var state = { color: null, size: null, qty: 1 };
var variant = P.variants.filter(function(v){ return v.available; })[0] || P.variants[0];
if (colorIdx > -1) state.color = variant.options[colorIdx];
if (sizeIdx > -1) state.size = variant.options[sizeIdx];
function findVariant(color, size){
return P.variants.filter(function(v){ return (colorIdx < 0 || v.options[colorIdx] === color) && (sizeIdx < 0 || v.options[sizeIdx] === size); })[0];
}
var slides = $$('[data-sz-slide]', root), thumbs = $$('[data-sz-thumb]', root), cur = 0;
function show(i){
if (!slides.length) return;
cur = (i + slides.length) % slides.length;
slides.forEach(function(s, k){ s.classList.toggle('is-active', k === cur); });
thumbs.forEach(function(t, k){ t.classList.toggle('is-active', k === cur); });
var t = thumbs[cur]; if (t) { var list = t.parentElement; list.scrollTo({ left: t.offsetLeft - list.offsetLeft - list.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' }); }
}
thumbs.forEach(function(t, k){ t.addEventListener('click', function(){ show(k); }); });
$$('[data-sz-gal-prev]', root).forEach(function(b){ b.addEventListener('click', function(){ show(cur - 1); }); });
$$('[data-sz-gal-next]', root).forEach(function(b){ b.addEventListener('click', function(){ show(cur + 1); }); });
function showMedia(mediaId){ if (!mediaId) return; slides.forEach(function(s, k){ if (s.getAttribute('data-media-id') === String(mediaId)) show(k); }); }
var OFF = P.bundles;
function update(){
variant = findVariant(state.color, state.size) || variant;
var price = variant.price, cmp = variant.compare_at_price && variant.compare_at_price > price ? variant.compare_at_price : 0;
$$('[data-sz-price]', root).forEach(function(e){ e.textContent = money(price); });
$$('[data-sz-cmp]', root).forEach(function(e){ e.textContent = cmp ? money(cmp) : ''; e.style.display = cmp ? '' : 'none'; });
var pct = cmp ? Math.round((cmp - price) * 100 / cmp) : 0;
$$('[data-sz-savepct]', root).forEach(function(e){ e.textContent = pct; var sv = e.closest('.sz-save'); if (sv) sv.style.display = pct ? '' : 'none'; });
$$('[data-sz-color-label]', root).forEach(function(e){ e.textContent = state.color || ''; });
$$('[data-sz-size-label]', root).forEach(function(e){ e.textContent = state.size || ''; });
$$('[data-sz-color]', root).forEach(function(c){ c.classList.toggle('is-active', c.getAttribute('data-value') === state.color); });
$$('[data-sz-size]', root).forEach(function(b){
var v = findVariant(state.color, b.getAttribute('data-value'));
b.classList.toggle('is-active', b.getAttribute('data-value') === state.size);
b.classList.toggle('is-disabled', !v || !v.available);
});
$$('[data-sz-bundle]', root).forEach(function(card){
var q = parseInt(card.getAttribute('data-qty'), 10), off = OFF[q] || 0;
var bp = $('[data-sz-bprice]', card), bc = $('[data-sz-bcmp]', card);
if (bp) bp.textContent = money(price * q * (1 - off));
if (bc) { var c = (cmp || price) * q; bc.textContent = c > price * q * (1 - off) ? money(c) : ''; }
card.classList.toggle('is-active', q === state.qty);
});
var sp = $('[data-sz-sticky-price]', root); if (sp) sp.textContent = money(price);
var atc = $('[data-sz-atc]', root);
if (atc) { atc.disabled = !variant.available; atc.textContent = variant.available ? atc.getAttribute('data-text') : 'Sold out'; }
if (P.updateUrl && window.history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', variant.id); window.history.replaceState({}, '', u.toString()); }
updateMix();
}
$$('[data-sz-color]', root).forEach(function(c){
c.addEventListener('click', function(){ state.color = c.getAttribute('data-value'); var v = findVariant(state.color, state.size); if (v && v.featured_media_id) showMedia(v.featured_media_id); else showMedia(c.getAttribute('data-media')); update(); });
});
$$('[data-sz-size]', root).forEach(function(b){ b.addEventListener('click', function(){ state.size = b.getAttribute('data-value'); update(); }); });
$$('[data-sz-bundle]', root).forEach(function(card){
card.addEventListener('click', function(e){ if (e.target.closest('.sz-addons')) return; state.qty = parseInt(card.getAttribute('data-qty'), 10); update(); });
});
function updateMix(){
var box = $('[data-sz-mix]', root); if (!box) return;
var total = 0;
$$('[data-sz-mix-row]', box).forEach(function(row){
var c = $('[data-mix-color]', row).value, sEl = $('[data-mix-size]', row), s = sEl ? sEl.value : null;
var v = findVariant(c, s) || variant;
row._variant = v; total += v.price;
var img = $('[data-mix-img]', row), src = P.colorImages[c];
if (img && src) img.innerHTML = '<img src="' + esc(src) + '" alt="">';
});
$('[data-mix-price]', box).textContent = money(total * (1 - (OFF[2] || 0)));
$('[data-mix-cmp]', box).textContent = money(total);
}
$$('[data-sz-mix] select', root).forEach(function(s){ s.addEventListener('change', updateMix); });
var mixBtn = $('[data-sz-mix-add]', root);
mixBtn && mixBtn.addEventListener('click', function(){ addItems($$('[data-sz-mix-row]', root).map(function(r){ return { id: r._variant.id, quantity: 1 }; }), mixBtn); });
var atc = $('[data-sz-atc]', root);
function addMain(btn){
var items = [{ id: variant.id, quantity: state.qty }];
if (state.qty === 1 || P.addonsAllBundles) { $$('[data-sz-addon]:checked', root).forEach(function(cb){ items.push({ id: parseInt(cb.value, 10), quantity: 1 }); }); }
addItems(items, btn);
}
atc && atc.addEventListener('click', function(){ addMain(atc); });
var sticky = $('[data-sz-sticky]', root);
if (sticky && atc && 'IntersectionObserver' in window) {
var sb = $('[data-sz-sticky-atc]', sticky);
sb && sb.addEventListener('click', function(){ addMain(sb); });
new IntersectionObserver(function(en){ en.forEach(function(x){ sticky.classList.toggle('is-show', !x.isIntersecting && x.boundingClientRect.top < 0); }); }).observe(atc);
}
$$('[data-sz-eta]', root).forEach(function(e){
var a = parseInt(e.getAttribute('data-min'), 10) || 14, b = parseInt(e.getAttribute('data-max'), 10) || 34;
function add(n){ var d = new Date(); d.setDate(d.getDate() + n); return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
e.textContent = add(a) + ' – ' + add(b);
});
update();
});
$$('[data-sz-track]').forEach(function(f){
f.addEventListener('submit', function(e){
e.preventDefault();
var n = $('input', f).value.trim(); if (!n) return;
window.open((f.getAttribute('data-url') || 'https://t.17track.net/en#nums=') + encodeURIComponent(n), '_blank', 'noopener');
});
});
})();